import queryString from 'query-string';
import gsap from 'gsap';

/**
 * Copy of spinner button per import statement at the top.
 */
export const getSpinner = () => {
	return `
  <svg version="1.1"
    id="svg-spinner"
    x="0px"
    y="0px"
    viewBox="0 0 80 80"
    xml:space="preserve">

    <path
        id="spinner"
        fill="##0f881a"
        d="M40,72C22.4,72,8,57.6,8,40C8,22.4,
        22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2
        s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,
        28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z">

        <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 40 40"
            to="360 40 40"
            dur="0.8s"
            repeatCount="indefinite"
        />
    </path>
</svg>
  `;
};

export default function(settings, mainScroll) {
	let page = 2;
	let buttonContent;
	let headers;

	if (!settings.buttonEl || !settings.containerEl) {
		return;
	}

	settings.buttonEl.addEventListener('click', () => {
		const query = queryString.stringify(
			Object.assign({}, { page: page }, settings.query),
		);
		const endpoint = `${window.location.protocol}//${window.location.host}/wp-json/wp/v2/${settings.resource}?${query}&_embed`;

		/**
		 * Conditionally show spinner and store original innerHTML for later.
		 */
		if (settings.showSpinner) {
			buttonContent = settings.buttonEl.innerHTML;
			settings.buttonEl.classList.remove('btn');
			settings.buttonEl.innerHTML = getSpinner();
		}

		fetch(endpoint)
			.then(response => {
				/**
				 * Conditionally remove spinner and put button content back.
				 */
				if (settings.showSpinner) {
					settings.buttonEl.innerHTML = buttonContent;
					settings.buttonEl.classList.add('btn');
				}

				/**
				 * Store response headers so we can see if more posts exists.
				 */
				headers = parseInt(response.headers.get('X-WP-TotalPages'));

				/**
				 * If we have a good response, then parse it's json.
				 */
				if (response.ok) {
					return response.json();
				}
			})
			.then(json => {
				if (json.length) {
					/**
					 * Loop over each post in the response, and call the callback
					 * function on each element.
					 */
					json.forEach(post => {
						let itemHTML = settings.callback(post);

						/**
						 * If the the callback result is an HTMLElement then we simply append it to
						 * the parent wrapper.
						 */
						if (1 === itemHTML.nodeType) {
							gsap.set(itemHTML, { y: 25, autoAlpha: 0 });
							settings.containerEl.appendChild(itemHTML);
							gsap.to(itemHTML, {
								duration: 0.6,
								delay: 0.2,
								y: 0,
								autoAlpha: 1,
								ease: 'power4.out',
							});
						}
					});

					/**
					 * We need to check the headers we stored earlier to see if more posts
					 * exist. If not then we can hide the load more button since there
					 * are no more posts to load.
					 */
					if (page === headers) {
						settings.buttonEl.style.display = 'none';
					}

					/**
					 * Increament the page count so that we continue to fetch the next page
					 * of results from the Rest API.
					 */
					page++;

					/**
					 * Update elements position
					 */
					mainScroll.update();
				}
			});
	});
}



// WEBPACK FOOTER //
// ./scripts/components/loadMore.js